import React from "react";
import { cn } from "../../lib/utils";
import styles from "./form-input.module.css";

import InputLoader from "./InputLoader";

// Copied from CartStorage for safety
function isLocalStorageAvailable() {
  try {
    if (typeof window === "undefined" || typeof window.localStorage === "undefined") {
      return false;
    }
    const testKey = "__form_input_storage_test__";
    window.localStorage.setItem(testKey, testKey);
    window.localStorage.removeItem(testKey);
    return true;
  } catch (e) {
    console.warn(`LocalStorage (for FormInput) is not available or accessible: ${e.message}`);
    return false;
  }
}

class FormInput extends React.Component {
  render() {
    let { isError, inputValue, isFocus, isInvalid, isLoading } = this.state;

    const {
      type,
      placeholder,
      errorMessage,
      maxLength,
      inputType,
      invalidMessage,
      userInterface,
      onKeyDown,
      textArea,
      name,
      color,
      inputBgColor,
      isInputBgSecondary,
      readOnly,
      disabled,
    } = this.props;

    const formInputClass = type === "full" ? styles.formInput : styles.halfInput;

    const inputClass = isFocus
      ? styles.focusInput
      : cn(styles.inputClass, isInputBgSecondary ? `!bg-secondary` : `!bg-${inputBgColor}`);

    return (
      <div className={formInputClass}>
        {errorMessage ? isError && <div className={styles.error}>{errorMessage}</div> : null}
        {invalidMessage ? isInvalid && <div className={styles.error}>{invalidMessage}</div> : null}
        <div className={inputClass} style={{ border: isError ? "1px solid red" : "" }}>
          {this.props.children}
          {userInterface === "loaded" && isLoading && <InputLoader />}
          {!isLoading &&
            (textArea ? (
              <textarea
                name={name}
                autoComplete="on"
                className={styles.inputStyle}
                placeholder={placeholder}
                value={inputValue || ""}
                onFocus={this.onFocus}
                onBlur={this.onBlur}
                maxLength={maxLength}
                disabled={disabled || false}
                readOnly={readOnly}
                onChange={this.onChange}
                ref={this.inputRef}
                onKeyDown={onKeyDown}
                style={{ "--input-color": color }}
              />
            ) : (
              <input
                name={name}
                autoComplete="on"
                className={styles.inputStyle}
                placeholder={placeholder}
                value={inputValue || ""}
                onFocus={this.onFocus}
                onBlur={this.onBlur}
                maxLength={maxLength}
                disabled={disabled || false}
                readOnly={readOnly}
                type={inputType}
                onChange={this.onChange}
                ref={this.inputRef}
                onKeyDown={onKeyDown}
                style={{ "--input-color": color }}
              />
            ))}
        </div>
      </div>
    );
  }
  componentWillReceiveProps(nextProps) {
    const { isError } = nextProps;
    if (isError) {
      console.log({ nextProps });
      this.setState({ isInvalid: true, isError: true }, () => {
        this.inputRef.current.focus();
      });
    } else {
      this.setState({ isInvalid: false, isError: false }, () => {});
    }
  }
  constructor(props) {
    super(props);

    let isError = false;
    let isFocus = false;
    let isInvalid = false;
    let isLoading = false;

    this.state = { isError, isFocus, isInvalid, isLoading };

    this.inputRef = React.createRef();
  }

  componentDidMount() {
    let { value, name } = this.props;
    let localValue = null; // Default to null

    if (name && isLocalStorageAvailable()) {
      // Check availability
      try {
        localValue = window.localStorage.getItem(name);
      } catch (error) {
        console.warn(
          `Error getting item '${name}' from localStorage in FormInput: ${error.message}`,
        );
        localValue = null; // Ensure null on error
      }
    }
    // Use component prop value > localStorage value > empty string
    this.setState({ inputValue: value || localValue || "" });
  }
  componentWillUnmount() {}

  validate = (isFocusAble) => {
    let { inputValue, isLoading } = this.state;
    let { regex } = this.props;

    if (isLoading) this.setState({ isLoading: false });

    return new Promise((resolve) => {
      const { isValid, type, isInvalid, isError } = this.validateMethod({
        regex,
        inputValue,
      });
      if (isValid) {
        if (isError) {
          this.setState({ isError: false }, () => {
            resolve(true);
          });
        }
        if (isInvalid) {
          this.setState({ isInvalid: false }, () => {
            resolve(true);
          });
        }
      } else {
        if (type == "validation") {
          this.setState({ isInvalid: true, isError }, () => {
            this.inputRef.current.focus();
            resolve(false);
          });
          return;
        }
        if (type == "error") {
          this.setState({ isError: true, isInvalid }, () => {
            if (isFocusAble) this.inputRef.current.focus();
            resolve(false);
          });
          return;
        }
      }
      this.setState({ isError: false, isInvalid: false });
      resolve(true);
    });
  };

  validateMethod = ({ regex, inputValue }) => {
    const { isOptional } = this.props;

    if (!regex && inputValue)
      return {
        isValid: true,
        isError: false,
        isInvalid: false,
      };
    else if (!inputValue && !isOptional) {
      return {
        isValid: false,
        isError: true,
        isInvalid: false,
        type: "error",
      };
    } else if (!inputValue && isOptional) {
      return {
        isValid: true,
        isError: false,
        isInvalid: false,
      };
    } else if (inputValue && regex && regex.test(inputValue)) {
      return {
        isValid: true,
        type: "validation",
        isError: false,
        isInvalid: false,
      };
    } else if (inputValue && regex && !regex.test(inputValue)) {
      return {
        isValid: false,
        type: "validation",
        isInvalid: true,
        isError: false,
      };
    } else {
      return {
        isValid: false,
        type: "error",
        isError: true,
        isInvalid: true,
      };
    }
  };

  onFocus = () => {
    // this.setState({ isFocus: true, isError: false, isInvalid: false });
    this.setState({ isFocus: true });
  };

  onBlur = () => {
    this.setState({ isFocus: false }, () => {
      let { onBlur } = this.props;
      let { inputValue } = this.state;

      // if (!inputValue) {
      //   this.validate();
      //   return;
      // }

      if (typeof onBlur !== "function") return;
      onBlur(inputValue);
    });
  };

  onChange = (e) => {
    const { saveInLocalStorage, name, maxLength, inputType } = this.props;
    let newValue = e.target.value;

    if (inputType === "number" && maxLength && newValue.length > maxLength) {
      newValue = newValue.slice(0, maxLength);
    }

    this.setState({ inputValue: newValue });

    if (saveInLocalStorage && name && isLocalStorageAvailable()) {
      // Check availability
      try {
        window.localStorage.setItem(name, newValue);
      } catch (error) {
        console.warn(`Error setting item '${name}' in localStorage in FormInput: ${error.message}`);
      }
    }

    const { onChange } = this.props;
    if (typeof onChange !== "function") return;
    onChange(newValue);
  };

  setValue = (value) => {
    this.setState({ isLoading: false }, () => {
      this.setState({ inputValue: value });
    });
  };

  focus = () => {
    this.inputRef.current.focus();
  };

  setLoader = (isLoading) => {
    this.setState({ isLoading }, () => {
      setTimeout(() => {
        this.setState({ isLoading: false });
      }, 5200);
    });
  };
}

export default FormInput;
